import api from '../services/api';

export const getFile = async (filePath) => {
  const response = await api.get(filePath, {
    responseType: 'blob',
  });

  return response.data;
};
